function parse(value) {
  try { return JSON.parse(value); } catch { return null; }
}
function tokenIdentity(token) {
  try {
    const payload = token?.split('.')[1];
    if (!payload) return null;
    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
    const claims = parse(atob(normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=')));
    const subject = claims?.sub || claims?.user_id || claims?.id;
    if (!subject) return null;
    // This is change detection, not token validation. The backend remains the
    // authority. Expiry/issued-at changes alone must not interrupt a refresh.
    return JSON.stringify([subject, claims.iss, claims.aud, claims.app_id, claims.app_slug,
      claims.tenant_id || claims.tenant || claims.tenant_slug, claims.tenants, claims.roles]);
  } catch { return null; }
}
function tenantIdentity(context) { return context?.id || context?.slug || null; }

export function installAuthStorageSync({target, storage, auth, onIdentityChange}) {
  let invalidated = false;
  const handle = event => {
    if (invalidated || (event.storageArea && event.storageArea !== storage)) return;
    if (event.key !== null && !['auth_token', 'refresh_token', 'tenant_context'].includes(event.key)) return;
    // Read the latest values, not an older queued event's payload.
    const token = storage.getItem('auth_token');
    const tenant = parse(storage.getItem('tenant_context'));
    const previousIdentity = tokenIdentity(auth.token);
    const nextIdentity = tokenIdentity(token);
    const tokenChanged = token !== auth.token;
    const identityChanged = event.key === null
      || tenantIdentity(tenant) !== tenantIdentity(auth.tenantContext)
      || (tokenChanged && (!previousIdentity || !nextIdentity || previousIdentity !== nextIdentity));
    auth.token = token;
    auth.refreshToken = storage.getItem('refresh_token');
    auth.tenantContext = tenant;
    if (tokenChanged) auth.sessionSyncedToken = null;
    if (identityChanged) {
      invalidated = true;
      onIdentityChange();
    }
  };
  target.addEventListener('storage', handle);
  return () => target.removeEventListener('storage', handle);
}
